import { CardArticle } from '@core/component';
import { urlFor } from '@core/sanity';
import { EActionAttribute, EColor, ERouting } from '@core/type';
import { SanityBlogHomeArticles } from '@core/type/sanity';

export const BlogArticle = ({ article }: { article: SanityBlogHomeArticles[number] }) => (
  <CardArticle
    {...article.body}
    title={article.title}
    subtitle={article.subtitle}
    image={{
      ...article.body.image,
      src: urlFor(article.body.image),
    }}
    headerColor={EColor.PRIMARY}
    categoryColor={EColor.ACCENT}
    actionAttribute={EActionAttribute.H2}
    iconColor={EColor.ACCENT}
    withDefaultImage
    linkTranslatedProps={{
      keyRoute: ERouting.BLOG_ARTICLE,
      query: {
        category: article.body?.category?.pageSlug?.slug?.current,
        slug: article.pageSlug?.slug.current,
      },
    }}
  />
);
